import { render, staticRenderFns } from "./FileImportLicensingTable.vue?vue&type=template&id=629328e7&"
import script from "./FileImportLicensingTable.vue?vue&type=script&lang=js&"
export * from "./FileImportLicensingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports